// Mock data for individual project metrics

interface ProjectMetricData {
  sopDeviation: {
    value: number;
    trend: string;
    trendValue: string;
    trendDirection: 'up' | 'down';
  };
  dealSentiment: {
    value: number;
    trend: string;
    trendValue: string;
    trendDirection: 'up' | 'down';
  };
  callQuality: {
    value: number;
    trend: string;
    trendValue: string;
    trendDirection: 'up' | 'down';
  };
}

interface ProjectsMetricsData {
  [projectName: string]: ProjectMetricData;
}

// Mock data for different projects
export const projectsMetricsData: ProjectsMetricsData = {
  'Birla': {
    sopDeviation: {
      value: 68.7,
      trend: 'Up by',
      trendValue: '5.2%',
      trendDirection: 'up'
    },
    dealSentiment: {
      value: 72,
      trend: 'Up by',
      trendValue: '3%',
      trendDirection: 'up'
    },
    callQuality: {
      value: 62,
      trend: 'Up by',
      trendValue: '7 points',
      trendDirection: 'up'
    }
  },
  'Dugasta': {
    sopDeviation: {
      value: 58.2,
      trend: 'Down by',
      trendValue: '2.8%',
      trendDirection: 'down'
    },
    dealSentiment: {
      value: 64,
      trend: 'Down by',
      trendValue: '6%',
      trendDirection: 'down'
    },
    callQuality: {
      value: 51,
      trend: 'Down by',
      trendValue: '3 points',
      trendDirection: 'down'
    }
  },
  'Eldeco Edge': {
    sopDeviation: {
      value: 75.3,
      trend: 'Up by',
      trendValue: '8.1%',
      trendDirection: 'up'
    },
    dealSentiment: {
      value: 82,
      trend: 'Up by',
      trendValue: '7%',
      trendDirection: 'up'
    },
    callQuality: {
      value: 68,
      trend: 'Up by',
      trendValue: '5 points',
      trendDirection: 'up'
    }
  },
  'M3M Panipat': {
    sopDeviation: {
      value: 61.5,
      trend: 'Up by',
      trendValue: '1.3%',
      trendDirection: 'up'
    },
    dealSentiment: {
      value: 69,
      trend: 'Down by',
      trendValue: '2%',
      trendDirection: 'down'
    },
    callQuality: {
      value: 57,
      trend: 'Up by',
      trendValue: '2 points',
      trendDirection: 'up'
    }
  },
  'M3M Cullinan': {
    sopDeviation: {
      value: 59.8,
      trend: 'Down by',
      trendValue: '3.6%',
      trendDirection: 'down'
    },
    dealSentiment: {
      value: 65,
      trend: 'Down by',
      trendValue: '5%',
      trendDirection: 'down'
    },
    callQuality: {
      value: 49,
      trend: 'Down by',
      trendValue: '6 points',
      trendDirection: 'down'
    }
  },
  'IC': {
    sopDeviation: {
      value: 70.4,
      trend: 'Up by',
      trendValue: '4.7%',
      trendDirection: 'up'
    },
    dealSentiment: {
      value: 78,
      trend: 'Up by',
      trendValue: '8%',
      trendDirection: 'up'
    },
    callQuality: {
      value: 64,
      trend: 'Up by',
      trendValue: '9 points',
      trendDirection: 'up'
    }
  }
};

// Default data for "All Projects" view
export const defaultMetricsData: ProjectMetricData = {
  sopDeviation: {
    value: 62.4,
    trend: 'Up by',
    trendValue: '3%',
    trendDirection: 'up'
  },
  dealSentiment: {
    value: 70,
    trend: 'Down by',
    trendValue: '5%',
    trendDirection: 'down'
  },
  callQuality: {
    value: 55,
    trend: 'Up by',
    trendValue: '4 points',
    trendDirection: 'up'
  }
};

// Function to get project metrics data
export const getProjectMetricsData = (projectName: string): ProjectMetricData => {
  if (projectName === 'All Projects') {
    return defaultMetricsData;
  }
  
  return projectsMetricsData[projectName] || defaultMetricsData;
}; 